<div class="readmore-modal">
  <div class="readmore-modal-card">

    <!-- Modal header with tabs and close button -->
    <div class="readmore-modal-header">
      <div class="readmore-tabs">
        <button
          *ngIf="data.contents.length"
          class="tab"
          [class.active]="activeTab === 'general'"
          (click)="activeTab = 'general'">
          {{ 'General' | translate }}
        </button>

        <button
          class="tab"
          [class.active]="activeTab === 'maintenance'"
          (click)="activeTab = 'maintenance'">
          {{ 'Maintenance' | translate }}
        </button>
      </div>

      <button class="close-btn" (click)="onCloseDialog()">×</button>
    </div>

    <!-- Modal body -->
    <div class="modal-body">

      <!-- General Tab Content -->
      <section *ngIf="data.contents.length && activeTab === 'general'">
        <ng-container>
          <div class="stack">
            <div class="card" *ngFor="let row of data.contents">
              <p class="content">
                {{ row['content'] }}
              </p>

              <div class="date">
                {{ row['created_at'] | date:'d/M/yyyy' }}
              </div>
            </div>
          </div>
        </ng-container>
      </section>

      <!-- Maintenance Tab Content -->
      <section *ngIf="activeTab === 'maintenance'">
        <ng-container *ngIf="data.maintenances.length; else noMaint">

          <div class="stack">
            <div class="card" *ngFor="let m of data.maintenances">
              <div class="maint-title">
                <span class="name">
                  {{ m.provider_name }} ({{ m.category_name | translate}})
                </span>
                <span *ngIf="m.is_ongoing" class="badge">{{ 'Ongoing' | translate }}</span>
              </div>

              <div class="maint-sub">
                <span class="when">
                  {{ m.display_time.replace('Until Further Notice', ('Until Further Notice' | translate)) }}
                </span>
              </div>
            </div>

            <div class="alert-soft">
              {{ 'Kindly continue enjoying the other available game providers. We sincerely apologise for any inconvenience caused.' | translate}}
            </div>
          </div>

        </ng-container>

        <ng-template #noMaint>
          <div class="alert-soft">
            {{ 'No Upcoming Maintenance Scheduled' | translate }}
          </div>
        </ng-template>
      </section>

    </div>
  </div>
</div>
